module.exports = __webpack_public_path__ + "img/dp-profile.614a9b70.jpg";